import makeUrl from "../../utils/make-url";
import config from "../config";

const routes = config.egyptParty;
const root = `/${routes.root}`;

export const index = (...args) => makeUrl(root, ...args);

export default {
  index,
};
